var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "1.27 1.25 21.53 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.12,
    x: 2.04248,
    y: 2,
    width: 20,
    height: 20,
    rx: 10,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0425 1.25C6.10542 1.25 1.29248 6.06294 1.29248 12C1.29248 17.9371 6.10542 22.75 12.0425 22.75C17.9795 22.75 22.7925 17.9371 22.7925 12C22.7925 6.06294 17.9795 1.25 12.0425 1.25ZM2.79248 12C2.79248 6.89137 6.93385 2.75 12.0425 2.75C17.1511 2.75 21.2925 6.89137 21.2925 12C21.2925 17.1086 17.1511 21.25 12.0425 21.25C6.93385 21.25 2.79248 17.1086 2.79248 12ZM12.7925 8C12.7925 7.58579 12.4567 7.25 12.0425 7.25C11.6283 7.25 11.2925 7.58579 11.2925 8V12C11.2925 12.2508 11.4178 12.4849 11.6265 12.624L14.6265 14.624C14.9711 14.8538 15.4368 14.7607 15.6665 14.416C15.8963 14.0714 15.8032 13.6057 15.4585 13.376L12.7925 11.5986V8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default "/Frontend/static/media/time.042382fcaf56f765f95fa4dc10cfea94.svg";
export { ForwardRef as ReactComponent };